import React, { useState } from 'react';
import Button from 'shared/button';

import { BrokerError, BrokerPanel, deleteRecord, modifyRecordArray } from '../broker_titles/shared';
import TerritoryEditModal from './edit_modal';

export type GeoJsonPolygon = {
  type: 'Polygon';
  coordinates: number[][][]; // [ring][point][lng/lat]
} | {
  type: 'MultiPolygon';
  coordinates: number[][][][]; // [polygon][ring][point][lng/lat]
};

export type Territory = {
  id: number;
  countryId: number;
  state: string;
  county: string;
  label: string;
  displayLabel: string;
  canModify?: boolean;
  boundary?: GeoJsonPolygon;
}

export type TerritoriesTabProps = {
  googleMapsApiKey?: string;
  territoryList: Territory[];
}

export default function TerritoriesTab({ googleMapsApiKey, territoryList }: TerritoriesTabProps) {
  const [territories, setTerritories] = useState<Territory[]>(territoryList);
  const [modalObject, setModalObject] = useState<{ isOpen: boolean; id: number | '' }>({ isOpen: false, id: '' });
  const [error, setError] = useState('');

  const openModal = (id: number | '') => setModalObject({ isOpen: true, id });
  const closeModal = () => setModalObject({ isOpen: false, id: '' });
  const territoryToEdit =
    typeof modalObject.id === 'number'
      ? territories.find(territory => territory.id === modalObject.id) || null
      : null;

  const handleFormSubmit = (newTerritory: Territory) => {
    modifyRecordArray(newTerritory, setTerritories, territories, 'label', modalObject, closeModal);
  };

  const deleteTerritory = ({ label, id }: { label?: string; id: number }) => {
    const displayLabel = label || 'Territory';
    deleteRecord(id, displayLabel, '/territories', 'Territory', setTerritories, setError);
  };

  const addNewTerritory = () => openModal('');

  return (
    <React.Fragment>
      <TerritoryEditModal
        isOpen={modalObject.isOpen}
        territory={territoryToEdit}
        onClose={closeModal}
        onSuccess={handleFormSubmit}
        googleMapsApiKey={googleMapsApiKey}
      />

      <div className="d-flex justify-content-between mb-3 align-items-center">
        <h2 className="m-0">Territories</h2>
        <Button.Primary type="button" onClick={addNewTerritory}>Add Territory</Button.Primary>
      </div>

      <BrokerError error={error}/>
      <BrokerPanel
        cantModifyMessage="Corporate Territory"
        deleteRecord={deleteTerritory}
        firstColumnIdentifier="displayLabel"
        openModal={openModal}
        recordName="Territory"
        records={territories}
        secondColumnIdentifier=""
        onClick={addNewTerritory}
      />
    </React.Fragment>
  );
}
